import React from 'react';
import styles from './ClientsContent.module.scss';
import { Button } from 'antd';
import cn from 'classnames';
import PhoneNumber from '../../../../../../components/PhoneNumber/PhoneNumber';

const maxSize = 1;

const ClientsContent = ({ clients, isExpanded, className }) => {
  const itemsToRender = isExpanded
    ? clients ?? []
    : (clients ?? []).slice(0, maxSize);

  return (
    <ul className={cn(styles.root, className)}>
      {itemsToRender.map((item, index) => (
        <li
          key={item.id ?? index}
          className={styles.item}
        >
          <div style={{ fontSize: 16, color: 'black' }}>
            {item.fio || item.name || 'Нет данных о владельце'}
          </div>
          {isExpanded && item.phone.length && (
            <div onClick={(e) => e.stopPropagation()}>
              {Array.isArray(item.phone) &&
                item.phone.map((telNum) => {
                  return (
                    <PhoneNumber
                      isIcon
                      phoneNumber={telNum}
                      name={item.fio || item.name || 'Нет данных о владельце'}
                    />
                  );
                })}
              {!Array.isArray(item.phone) && (
                <PhoneNumber
                  isIcon
                  phoneNumber={item.phone}
                  name={item.fio || item.name || 'Нет данных о владельце'}
                />
              )}
            </div>
          )}
        </li>
      ))}
      {clients.length > maxSize && (
        <li>
          <Button
            type="link"
            className={styles.toggleItemsBtn}
          >
            {isExpanded ? 'Скрыть' : `+ еще ${clients.length - maxSize}`}
          </Button>
        </li>
      )}
    </ul>
  );
};

export default ClientsContent;
